<template lang="html">

  <el-radio-group v-model="id" @change="selectChange" >
       <el-radio v-for="(item,index) in selectArr" :key="index" border size="medium" :label="item.id">{{item.name}}</el-radio>
       <div v-if="id" @click="clearSelect" class="iconBtn">
            <i class="icon el-icon-close"></i>
       </div>
  </el-radio-group>

</template>

<script>
import { dicSeek } from "@/api/pgMent/dictMent";
export default {
    name:'radioSelect',
    props:['code','selectId','paramsKey','mapKey'],
    watch:{
         selectId:function(e){
             this.id = e;
         }
    },
    data(){
        return{
            id:'',
            selectArr:[],
            dectMap:{}
        }
    },
    methods:{
        selectChange:function(e){
            this.$emit('selectChange',{
                id:e,
                name:this.dectMap[this.id],
                paramsKey:this.paramsKey
            })
        },

        clearSelect:function(){
            this.id = '';
            this.$emit('selectChange',{
                id:'',
                name:'',
                paramsKey:this.paramsKey
            })
        }
    },
    created:function(){
        var vues = this;
        dicSeek({code:this.code}).then(res => {
            var unFormate = res.dataDictionarys;
            vues.selectArr = unFormate;
            for(var i = 0;i < unFormate.length;i++){
                vues.dectMap[unFormate[i].id] = unFormate[i].name;
            }
            vues.$emit('getMap',{
                map:vues.dectMap,
                mapKey:vues.mapKey
            })
        })
    }

}
</script>

<style lang="css" scoped>

.iconBtn{
    color: #AEAEAE;
    display: inline-block;
    margin-left: 12px;
    width: 18px;
    height: 18px;
    text-align: center;
    background: #F5F5F5;
    cursor: pointer;
}

.iconBtn .icon{
    font-size: 9px;
    margin-top: 3px;
    color: #AEAEAE;
}

</style>



// WEBPACK FOOTER //
// radioSelect.vue?26a90487